import styled from 'styled-components';

/**
 * Styled app store button/link. Renders as anchor when href is passed, otherwise as button.
 * MButtonApp has its own design distinct from MButton - it is not a variant of MButton.
 */
export const Button = styled.button`
  display: inline-flex;
  background-color: transparent;
  padding: 0;
  margin: 0;
`;

export const Link = styled.a`
  display: inline-flex;
`;

export const Label = styled.span`
  line-height: inherit;
`;
